import React from 'react';
import {Button} from '@/ui-kits';
import {ChatButton} from '../../../common';
import { useWindowDimensions } from '@/hooks';
import { screenSize } from '@/theme';
import { specialistDashboardSubmitSecondOpinionLoadingStatus } from '@/services/redux/selectors';
import { useSelector } from 'react-redux';

interface ActionButtonsProps {
  onSaveAsDraft: () => void;
  onSubmitSecondOpinion: () => void;
  onChatClick: () => void;
  chatId: number;
  disableSaveAsDraft?: boolean;
  disableSubmitSecondOpinion?: boolean;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({onSaveAsDraft, onSubmitSecondOpinion, onChatClick, chatId, disableSaveAsDraft, disableSubmitSecondOpinion}) => {
  const {width} = useWindowDimensions();
  const submitSecondOpinionLoading = useSelector(specialistDashboardSubmitSecondOpinionLoadingStatus);

  return (
    <>
      <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center max-w-xl w-full mx-auto">
        <Button
          title="Save As Draft"
          variant="secondary"
          className="w-full sm:flex-1 py-2.5 sm:py-2 rounded-lg flex items-center justify-center gap-2"
          onClick={onSaveAsDraft}
          disabled={disableSaveAsDraft}
        />
        <Button
          title="Submit Second Opinion"
          variant="primary"
          isLoading={submitSecondOpinionLoading}
          className="w-full sm:flex-1 py-2.5 sm:py-2 rounded-lg flex items-center justify-center gap-2"
          textClassName="whitespace-nowrap"
          onClick={onSubmitSecondOpinion}
          disabled={disableSubmitSecondOpinion}
        />
      </div>

      {/* Floating Chat Button */}
      <div className="fixed top-[50%] translate-y-1/2 right-8 z-50">
        <ChatButton onClick={onChatClick} chatId={chatId} size={width < screenSize['sm'] ? 'md' : "lg"} />
      </div>
    </>
  );
};

export default ActionButtons;
